import {
  apiClient,
  type PackageCategoryImportJobExEntity,
  type CreatePackageCategoryImportJobDto
} from '@/libs/api'

export type CreatePackageCategoryImportJobRequest = {
  tenantKey: string
  dto: CreatePackageCategoryImportJobDto
}

export const createPackageCategoryImportJob = async ({
  tenantKey,
  dto
}: CreatePackageCategoryImportJobRequest): Promise<PackageCategoryImportJobExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .package_category_import_jobs.$post({
      body: dto
    })
  return data
}
